import React,{useEffect} from "react";
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from "react-redux";

function Footer(props) {
    let dispatch = useDispatch();
  const navigate=useNavigate();
    // const [data, setData]=useState([]);
    useEffect(() => {

        }, []);

    const logout =()=> {
        var redirectUrl = sessionStorage.getItem("returnUrl");
        for (var i = 0; i < sessionStorage.length; i++) {
            var a = sessionStorage.key(i);
            sessionStorage.removeItem(a);
        }
        dispatch({ type: "USER_LOGOUT" });
        window.location.href = redirectUrl;
        //navigate("/");
    }
    return(
        <Box 
            width='100%'
            sx={{
                display: { xs: 'block', sm: 'none' }
            }}
        >


                        <Box
                            width='100%'
                            display='flex'
                            justifyContent='center'
                            sx={{paddingTop:'30px'}}
                            >
                            {props.takethesurvey &&(<Box component="img"
                            justifyContent='center'
                                sx={{ paddingLeft:'20px',paddingRight:'20px', width:'100%', maxWidth:'400px'}}
                                alt="Org Image"
                                src={process.env.PUBLIC_URL + "/images/complete-your-wheel-button.png"}
                                onClick={()=>{
                                    navigate("/survey");
                                    }}
                            />)}

                            {!props.takethesurvey &&(<Box component="img"
                            justifyContent='center'
                                sx={{ paddingLeft:'20px',paddingRight:'20px', width:'100%', maxWidth:'400px'}}
                                alt="Org Image"
                                src={process.env.PUBLIC_URL + "/images/back-to-dashboard-button.png"}
                                onClick={()=>{
                                    navigate("/dashboard");
                                    }}
                            />)}

                        </Box>
                        <Box
                            width='100%'
                            display='flex'
                            justifyContent='center'
                            sx={{paddingTop:'15px', paddingBottom:'10px'}}
                            >
                            <Box component="img"
                            justifyContent='center'
                                sx={{ paddingLeft:'20px',paddingRight:'20px', width:'100%', maxWidth:'400px'}}
                                alt="Org Image"
                                src={process.env.PUBLIC_URL + "/images/logout-button.png"}
                                onClick={()=>{
                                    logout();
                                    }}
                            />
                        </Box>
                        <Box
                            width='100%'
                            display='flex'
                            justifyContent='center'
                            sx={{paddingTop:'10px'}}>
                            <Typography sx={{fontSize:'14px', fontWeight:'400', color:'grey', paddingBottom:'20px'}}>
                              ©February, 2025 DECAMA Limited, All Rights Reserved.
                            </Typography>
                        </Box>

        </Box>
    );
}
export default Footer;